import * as React from "react";
const SvgFiRrChatbot = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-chatbot_svg__a)">
      <path
        fill="#062147"
        d="M6.5 16a1.5 1.5 0 1 1-.001 3.001A1.5 1.5 0 0 1 6.5 16m5 3a1.5 1.5 0 1 0-.001-3.001A1.5 1.5 0 0 0 11.5 19M24 3.998V6c0 2.206-1.794 4-4 4h-2.854l-2.435 1.696a1.76 1.76 0 0 1-.983.302A1.73 1.73 0 0 1 12 10.265V3.998c0-2.206 1.794-4 4-4h4c2.206 0 4 1.794 4 4m-2 0c0-1.103-.897-2-2-2h-4c-1.103 0-2 .897-2 2v5.757l2.262-1.575a1 1 0 0 1 .571-.18H20c1.103 0 2-.897 2-2zM16.5 15H16a1 1 0 1 0-2 0v5c0 1.103-.897 2-2 2H6c-1.103 0-2-.897-2-2v-5c0-1.103.897-2 2-2h3a1 1 0 0 0 1-1v-2a1 1 0 0 0-2 0v1H6c-2.206 0-4 1.794-4 4h-.5c-.827 0-1.5.673-1.5 1.5v2c0 .827.673 1.5 1.5 1.5H2c0 2.206 1.794 4 4 4h6c2.206 0 4-1.794 4-4h.5c.827 0 1.5-.673 1.5-1.5v-2c0-.827-.673-1.5-1.5-1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-chatbot_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrChatbot;
